import { PackageDataSet, PackageData, CTA_LABEL } from '~pricing/lib/summaryPackages';

/**
 * A utility the returns the current packages to display based on route
 * @param packages
 * @param packageSet
 * @returns
 */

/**
 * A utility to assign ctaLabel based on current user package,
 * the tier and authentication status
 * @param packages
 * @param currentPackage
 * @param authenticated
 * @returns PackageDataSet
 */
export default function assignCTABasedOnPackageTier(
  packages: PackageDataSet,
  currentPackage?: PackageData,
  authenticated?: boolean
): PackageDataSet {
  if (currentPackage && authenticated) {
    return packages.map((pkg: PackageData): PackageData => {
      const tempPackage = { ...pkg };
      if (currentPackage.id === pkg.id) {
        tempPackage.ctaLabel = CTA_LABEL.YOUR_PLAN;
      }
      if (pkg.details.tier < currentPackage?.details?.tier) {
        tempPackage.ctaLabel = CTA_LABEL.NOT_UPGRADEABLE;
      } else if (pkg.details.tier > currentPackage?.details?.tier) {
        tempPackage.ctaLabel = CTA_LABEL.SELECT;
      }
      return tempPackage;
    });
  }
  const tempPackages = packages.map(
    (pkg: PackageData): PackageData => ({
      ...pkg,
      ctaLabel: authenticated ? CTA_LABEL.SELECT : CTA_LABEL.SIGN_UP,
    })
  );

  return tempPackages;
}
